// removed by extract-text-webpack-plugin
module.exports = {"root":"order-list--root--u5qKWHLx","content":"order-list--content--2yiwgqad","background":"order-list--background--3CScxwMw","orders":"order-list--orders--pWAHxr58","table-div":"order-list--table-div--2HDAy110","tableDiv":"order-list--table-div--2HDAy110"};


//////////////////
// WEBPACK FOOTER
// ./views/order-list/styles.css
// module id = ./views/order-list/styles.css
// module chunks = 0